import React, { useMemo } from 'react'
import { Trans } from '@lingui/react'
import { x } from '@xstyled/styled-components'
import { Status as StatusType, statusToColor, StatusTrans, typeToColor } from '@typings/enums/StockAdvice'
import { Field, FormikValues } from 'formik'
import InfoHeader from '@components/blocks/InfoHeader'
import HighlightBox from '@components/elements/HighlightBoxReworked'
import InputField from '@components/forms/components/InputField'
import { StockAdviceType } from '@typings/entities/StockAdvice'
import { StockAdviceTypeTrans } from '@typings/enums/StockAdvice'

interface HeaderType {
  status?: keyof typeof StatusType
  adviceId?: string
  isEditable: boolean
  withReceipts?: boolean
  values: FormikValues
  type?: StockAdviceType
}

const Header = ({ status, values, isEditable, type }: HeaderType): JSX.Element => {
  const infoHeaderItems = useMemo(() => {
    const statusField = {
      label: <Trans id="form.status.label" message="Status" />,
      component: status && (
        <HighlightBox appearance={statusToColor[status]} size="default">
          {StatusTrans[status]()}
        </HighlightBox>
      ),
      isSmall: true,
    }

    return [
      [
        {
          label: <Trans id="form.adviceInternalId.label" message="Advice number" />,
          component: isEditable ? <Field name="internalId" component={InputField} /> : values?.internalId,
        },
        {
          label: <Trans id="form.adviceWmsId" message="Advice WMS ID" />,
          component: values?.wmsInternalId,
        },
      ],

      [
        ...(status ? [statusField] : []),
        ...(type
          ? [
              {
                label: <Trans id="form.adviceType" message="Advice type" />,
                component: status && (
                  <HighlightBox appearance={typeToColor[type]} size="default">
                    {StockAdviceTypeTrans[type]?.() || type}
                  </HighlightBox>
                ),
                isSmall: true,
              },
            ]
          : []),
      ],
    ]
  }, [isEditable, status, values?.internalId, values?.wmsInternalId, type])

  return (
    <x.div w="100%" minW="300px" mb={4} pr={2}>
      <InfoHeader items={infoHeaderItems} />
    </x.div>
  )
}

export default React.memo(Header)
